import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFavorites } from '../context/FavoritesContext';
import { useCart } from '../context/CartContext';
import './Favorites.css';

function Favorites() {
  const { favorites, removeFromFavorites } = useFavorites();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = (product) => {
    addToCart(product);
    navigate('/cart');
  };

  return (
    <div className="favorites-container">
      <div className="favorites-header">
        <h1>Saved Items</h1>
        <p className="favorites-count">
          {favorites.length} {favorites.length === 1 ? 'item' : 'items'} saved
        </p>
      </div>

      {favorites.length === 0 ? (
        <div className="empty-favorites">
          <div className="empty-icon">💔</div>
          <h2>No Saved Items</h2>
          <p>Start adding your favorite products to save them for later!</p>
          <Link to="/products" className="continue-shopping">
            Browse Products
          </Link>
        </div>
      ) : (
        <div className="favorites-grid">
          {favorites.map((product) => (
            <div key={product._id} className="favorite-product-card">
              <div className="product-image-wrapper">
                {product.images && product.images[0] ? (
                  <Link to={`/products/${product._id}`}>
                    <img src={product.images[0]} alt={product.name} />
                  </Link>
                ) : (
                  <div className="no-image">No Image</div>
                )}
                <button
                  className="remove-favorite"
                  onClick={() => removeFromFavorites(product._id)}
                  title="Remove from favorites"
                >
                  ✕
                </button>
              </div>

              <div className="product-details">
                <Link to={`/products/${product._id}`} className="product-name">
                  {product.name}
                </Link>

                <p className="culture-origin">{product.culturalOrigin}</p>

                <p className="product-description">
                  {product.description?.substring(0, 100)}...
                </p>

                <div className="product-footer">
                  <div className="price-section">
                    <span className="price">R{product.price?.toFixed(2)}</span>
                    {product.discountPrice && (
                      <span className="original-price">R{product.discountPrice?.toFixed(2)}</span>
                    )}
                  </div>

                  <button
                    className="add-to-cart-btn"
                    onClick={() => handleAddToCart(product)}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Favorites;
